<template>
    <el-cascader
        v-model="selected"
        :options="categories"
        :props="categoriesProps"
        @change="valChange"
        placeholder="请选择分类"
    ></el-cascader>
</template>

<script>
import { AllMedicalClass } from "@/api/category";
import { removeEmptyChildren } from "@/utils";

export default {
    name: "MedicalClassSelector",
    model: {
        prop: "defaultCategory",
        event: "change",
    },
    props: {
        defaultCategory: {
            type: [String, Number],
            default: () => 0,
        },
        addAll: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            categories: [],
            selected: [],
        };
    },
    watch: {
        defaultCategory(newValue, oldValue) {
            if (typeof newValue === "number") {
                this.handleDefault();
            }
            if (newValue == null) {
                this.selected = []
            }
        },
    },
    mounted() {
        this.getMedicalClass().then(() => {
            this.handleDefault();
        });
    },
    computed: {
        categoriesProps() {
            return {
                checkStrictly: true,
                label: "ClassName",
                value: "ClassId",
            };
        },
    },
    methods: {
        valChange(val) {
            if (val.length > 0) {
                this.$emit("change", val[val.length - 1]);
            } else {
                this.$emit("change", "");
            }
        },
        async getMedicalClass() {
            try {
                const { data } = await AllMedicalClass();
                this.categories = data.data;
                removeEmptyChildren(this.categories, "children");
                this.$emit("categories-load", this.categories)
                if (this.addAll) {
                    this.categories.splice(0, 0, {
                        ClassName: "全部",
                        ClassId: "",
                    });
                }
            } catch (err) {
                this.$toast("获取失败");
            }
        },
        // 处理默认值，当传进来的分类是数字时，生成对应 selected 数组
        handleDefault() {
            if (typeof this.defaultCategory === "number") {
                const findId = (list, ids) => {
                    for (const el of list) {
                        const l = Array.from(ids);
                        l.push(el.ClassId);
                        if (el.ClassId === this.defaultCategory) return l;
                        if (el.children) {
                            let ids = findId(el.children, l);
                            if (ids) return ids;
                        }
                    }
                };
                let ids = findId(this.categories, []);
                if (ids) {
                    this.selected = ids;
                }
            }
        },
    },
};
</script>

<style scoped>
</style>
